// import { MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { NativeDateAdapter } from '@angular/material/core';
// import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Inject, Injectable, Optional } from '@angular/core';

// import * as moment from 'moment';
// import * as _moment from 'moment';
// import {default as _rollupMoment} from 'moment';
// const moment = _rollupMoment || _moment;

@Injectable()
export class MyDateAdapter extends NativeDateAdapter {
// export class MyDateAdapter extends MomentDateAdapter {

  // constructor( @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
  //   super(dateLocale);
  // }

  // parse(value, parseFormat) {
  //   if (value && typeof value === 'string') {
  //     console.log(moment(value, parseFormat, this.locale, true));
  //     return moment(value, parseFormat, this.locale, true);
  //   }
  //   return value ? moment(value).locale(this.locale) : undefined;
  // }

  getFirstDayOfWeek(): number {
    return 1;
  }

}
